import React, { useEffect, useState } from "react";

const API = "https://api.haymestasarim.com/api";

export default function ReferansKazancPage() {
  const [loading, setLoading] = useState(true);
  const [earnings, setEarnings] = useState([]);
  const [error, setError] = useState(null);

  const [tab, setTab] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [requestAmount, setRequestAmount] = useState("");

  const token = localStorage.getItem("user_token");
const [bank, setBank] = useState(null);
const [payouts, setPayouts] = useState([]);

useEffect(() => {
  if (!token) return;

  fetch(`${API}/profile/bank`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => setBank(d || null))
    .catch(() => setBank(null));
}, [token]);

useEffect(() => {
  if (!token) return;

  fetch(`${API}/payout/my-requests`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => setPayouts(Array.isArray(d) ? d : []))
    .catch(() => setPayouts([]));
}, [token]);


  useEffect(() => {
    if (!token) return;

    fetch(`${API}/network/earnings`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => {
        setEarnings(Array.isArray(d) ? d : []);
        setLoading(false);
      })
      .catch(() => {
        setError("Kazançlar alınamadı");
        setLoading(false);
      });
  }, [token]);

  const sum = (status) =>
    earnings
      .filter(e => e.status === status)
      .reduce((t, e) => t + Number(e.amount), 0);
const availableTotal = sum("available");

const pendingDaysLeft = () => {
  const pendings = earnings.filter(e => e.status === "pending");
  if (!pendings.length) return 0;

  const earliest = pendings.reduce((a, b) =>
    new Date(a.created_at) < new Date(b.created_at) ? a : b
  );

  return remainingDays(earliest.created_at);
};


const handleRequest = async () => {
  const amount = Number(requestAmount);

  // 1) bakiye yok
  if (availableTotal <= 0) {
    alert("Çekilebilir bakiyeniz bulunmamaktadır.");
    return;
  }

  // 2) eşik kontrol (700 kuralı)
  if (availableTotal < 500) {
    alert("Çekilebilir bakiyeniz 500 TL’nin altında olduğu için ödeme talebi oluşturamazsınız.");
    return;
  }

  if (availableTotal < 700) {
    alert("Çekilebilir bakiyeniz 700 TL’nin altında olduğu için ödeme talebi oluşturamazsınız.");
    return;
  }

  // 3) IBAN kontrol
  const iban = String(bank?.iban || "").replace(/\s+/g, "");
  if (!iban) {
    alert("Ödeme talebi oluşturabilmek için lütfen önce Ayarlar > Banka Bilgileri bölümünden banka bilgilerinizi giriniz.");
    return;
  }

  // 4) tutar kontrol
  if (!amount || amount <= 0) {
    alert("Lütfen geçerli bir tutar giriniz.");
    return;
  }

  // İstersen burada da 700 minimumu uygula:
  if (amount < 700) {
    alert("Minimum ödeme talebi 700 TL’dir.");
    return;
  }

  if (amount > availableTotal) {
    alert("Talep ettiğiniz tutar, çekilebilir bakiyenizi aşamaz.");
    return;
  }

  try {
    const res = await fetch(`${API}/payout/request`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ amount }),
    });

    const data = await res.json();

    if (!res.ok) {
      alert(data?.message || "Ödeme talebiniz oluşturulamadı. Lütfen daha sonra tekrar deneyiniz.");
      return;
    }

    alert("Ödeme talebiniz alınmıştır. İncelenmesinden sonra banka hesabınıza aktarılacaktır.");

    setShowModal(false);
    setRequestAmount("");

    setLoading(true);
    fetch(`${API}/network/earnings`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => {
        setEarnings(Array.isArray(d) ? d : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));

  } catch (err) {
    alert("İşlem sırasında sunucuya ulaşılamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyiniz.");
  }
};

  const filteredEarnings = () => {
    if (tab === "available") return earnings.filter(e => e.status === "available");
    if (tab === "requests") return earnings.filter(e => e.status === "paid" || e.status === "requested");
    return earnings;
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Referans Kazançlarım</h2>
      <p style={styles.subtitle}>
        Referans sisteminden elde ettiğiniz tüm kazançları buradan takip edebilirsiniz.
      </p>

      {/* ÖZET KARTLAR */}
      <div style={styles.cards}>
<StatCard
  title={
    sum("pending") > 0
      ? `Bekleyen (${pendingDaysLeft()} Gün)`
      : "Bekleyen"
  }
  amount={sum("pending")}
  color="#f59e0b"
/>

  <StatCard title="Çekilebilir" amount={sum("available")} color="#10b981" />
  <StatCard title="Ödenen" amount={sum("paid")} color="#6366f1" />
</div>


      {/* SEKME */}
      <div style={styles.tabs}>
        <TabButton active={tab === "all"} onClick={() => setTab("all")}>Tüm Kazançlar</TabButton>
        <TabButton active={tab === "available"} onClick={() => setTab("available")}>Çekilebilir</TabButton>
        <TabButton active={tab === "requests"} onClick={() => setTab("requests")}>Ödeme Listem</TabButton>
<TabButton active={tab === "payouts"} onClick={() => setTab("payouts")}>
  Ödeme Taleplerim
</TabButton>
      </div>

      {/* ÇEKİLEBİLİR ÜST BLOK */}
      {tab === "available" && (
        <div style={styles.withdrawBox}>
          <div>
            <div style={styles.withdrawTitle}>Çekilebilir Bakiye</div>
            <div style={styles.withdrawAmount}>{availableTotal.toFixed(2)} ₺</div>
          </div>
         <button
  style={styles.withdrawBtn}
  onClick={() => {
    // 1) bakiye yok
    if (availableTotal <= 0) {
      alert("Çekilebilir bakiyeniz bulunmamaktadır.");
      return;
    }

    // 2) eşik kontrol (700 kuralı)
    if (availableTotal < 500) {
      alert("Çekilebilir bakiyeniz 500 TL’nin altında olduğu için ödeme talebi oluşturamazsınız.");
      return;
    }

    if (availableTotal < 700) {
      alert("Çekilebilir bakiyeniz 700 TL’nin altında olduğu için ödeme talebi oluşturamazsınız.");
      return;
    }

    // 3) iban kontrol
    const iban = String(bank?.iban || "").replace(/\s+/g, "");
    if (!iban) {
      alert("Ödeme talebi oluşturabilmek için lütfen önce Ayarlar > Banka Bilgileri bölümünden banka bilgilerinizi giriniz.");
      return;
    }

    setShowModal(true);
  }}
>
  Ödeme Talep Et
</button>

        </div>
      )}

      {/* TABLO */}
     {!loading && tab !== "payouts" && (
        <div style={styles.table}>
         <div style={styles.rowHeader}>
  <span>Seviye</span>
  <span>Kimden</span>
  <span>Tutar</span>
  <span>Durum</span>
  <span>Tarih</span>
</div>


          {filteredEarnings().map(e => (
          <div key={e.id} style={styles.row}>
<span style={{ fontWeight: 700, color: "#2563eb" }}>
  {levelText(e.level)}
</span>

  <span>
    {e.source_name || "—"}
  </span>

  <span>{Number(e.amount).toFixed(2)} {e.currency}</span>
<span style={statusStyle(e.status)}>
  {e.status === "pending"
    ? `Beklemede (${remainingDays(e.created_at)} gün)`
    : statusText(e.status)}
</span>
  <span>{new Date(e.created_at).toLocaleDateString()}</span>
</div>

          ))}
        </div>
      )}


{/* ================= ÖDEME TALEPLERİ TABLOSU ================= */}
{tab === "payouts" && (
  <div style={styles.table}>
    <div style={styles.rowHeader}>
      <span>Tutar</span>
      <span>Durum</span>
      <span>Talep Tarihi</span>
      <span>Onay Tarihi</span>
    </div>

    {payouts.length === 0 && (
      <div style={{ padding: 16, color: "#64748b" }}>
        Henüz oluşturulmuş bir ödeme talebiniz bulunmamaktadır.
      </div>
    )}

    {payouts.map(p => (
      <div key={p.id} style={styles.row}>
        <span>{Number(p.amount).toFixed(2)} ₺</span>

        <span
          style={{
            color: p.status === "requested" ? "#f59e0b" : "#10b981",
            fontWeight: 700
          }}
        >
          {p.status === "requested" ? "Onay Bekliyor" : "Onaylandı"}
        </span>

        <span>{new Date(p.created_at).toLocaleDateString()}</span>

        <span>
          {p.approved_at
            ? new Date(p.approved_at).toLocaleDateString()
            : "—"}
        </span>
      </div>
    ))}
  </div>
)}






      {/* MODAL */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Ödeme Talebi Oluştur</h3>
            <p>Çekilebilir Bakiye: <b>{availableTotal.toFixed(2)} ₺</b></p>

            <input
              type="number"
              placeholder="Talep edilecek tutar"
              value={requestAmount}
              onChange={e => setRequestAmount(e.target.value)}
              style={styles.input}
            />

<small>Minimum ödeme tutarı 700 TL’dir. Banka bilgileriniz tanımlı olmalıdır.</small>

            <div style={styles.modalActions}>
              <button onClick={() => setShowModal(false)}>Vazgeç</button>
              <button style={styles.withdrawBtn} onClick={handleRequest}>Talep Gönder</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ================= HELPERS ================= */

function remainingDays(createdAt, waitDays = 14) {
  const created = new Date(createdAt);
  const availableDate = new Date(created);
  availableDate.setDate(availableDate.getDate() + waitDays);

  const now = new Date();
  const diffMs = availableDate - now;
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
}



function levelText(level) {
  if (level === "mlm_l1") return "1. Kademe (%15)";
  if (level === "mlm_l2") return "2. Kademe (%10)";
  if (level === "mlm_l3") return "3. Kademe (%5)";
  if (level === "mlm_l4") return "4. Kademe (%2)";

  return level || "-";
}

function statusText(status) {
  if (status === "pending") return "Beklemede";
  if (status === "available") return "Çekilebilir";
  if (status === "paid") return "Ödendi";
  if (status === "requested") return "Onay Bekliyor";
  return status;
}

function statusStyle(status) {
  if (status === "pending") return { color: "#f59e0b", fontWeight: 600 };
  if (status === "available") return { color: "#10b981", fontWeight: 600 };
  if (status === "paid") return { color: "#6366f1", fontWeight: 600 };
  return {};
}

/* ================= COMPONENTS ================= */

function StatCard({ title, amount, color }) {
  return (
    <div style={{ ...styles.card, borderLeft: `6px solid ${color}` }}>
      <div style={styles.cardTitle}>{title}</div>
      <div style={{ ...styles.cardValue, color }}>{amount.toFixed(2)} ₺</div>
    </div>
  );
}

function TabButton({ active, children, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "10px 18px",
        borderRadius: 10,
        border: "none",
        background: active ? "#2563eb" : "#e5e7eb",
        color: active ? "#fff" : "#111",
        fontWeight: 700,
        cursor: "pointer"
      }}
    >
      {children}
    </button>
  );
}

/* ================= STYLES ================= */

const styles = {
  page: { padding: 32 },
  title: { fontSize: 26, fontWeight: 800 },
  subtitle: { color: "#64748b", marginBottom: 24 },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
    gap: 16,
    marginBottom: 24,
  },

  card: {
    background: "#fff",
    borderRadius: 16,
    padding: 18,
    boxShadow: "0 10px 25px rgba(0,0,0,.08)",
  },
  cardTitle: { fontSize: 14, color: "#64748b" },
  cardValue: { fontSize: 26, fontWeight: 800 },

  tabs: { display: "flex", gap: 12, marginBottom: 24 },

  withdrawBox: {
    background: "#f8fafc",
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  withdrawTitle: { color: "#64748b" },
  withdrawAmount: { fontSize: 28, fontWeight: 800 },
  withdrawBtn: {
    background: "#10b981",
    color: "#fff",
    border: "none",
    padding: "12px 18px",
    borderRadius: 10,
    fontWeight: 700,
    cursor: "pointer"
  },

  table: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 25px rgba(0,0,0,.08)",
    overflow: "hidden"
  },
rowHeader: {
  display: "grid",
  gridTemplateColumns: "1.5fr 1.5fr 1fr 1fr 1fr",
  padding: 16,
  background: "#f1f5f9",
  fontWeight: 700
},
row: {
  display: "grid",
  gridTemplateColumns: "1.5fr 1.5fr 1fr 1fr 1fr",
  padding: 16,
  borderTop: "1px solid #e5e7eb"
},

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  modal: {
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    width: 360
  },
  input: {
    width: "100%",
    padding: 12,
    borderRadius: 10,
    border: "1px solid #e5e7eb",
    marginBottom: 10
  },
  modalActions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 16
  }
};


/* =====================================================
   MOBILE RESPONSIVE OVERRIDE
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {

    styles.page.padding = 16;

    styles.cards.gridTemplateColumns = "1fr";

    styles.tabs.flexDirection = "column";
    styles.tabs.gap = 8;

    styles.withdrawBox.flexDirection = "column";
    styles.withdrawBox.alignItems = "flex-start";
    styles.withdrawBox.gap = 12;

    styles.withdrawBtn.width = "100%";

    styles.rowHeader.gridTemplateColumns = "1fr 1fr";
    styles.row.gridTemplateColumns = "1fr 1fr";

    styles.rowHeader.fontSize = 12;
    styles.row.fontSize = 13;

    styles.modal.width = "92%";

  }
}
